import React, { useEffect, useRef } from 'react';
import FilterBar from './filterBar';
import { useDispatch, useSelector } from 'react-redux';
import { getTriggers, getTriggersSummaryGraphs, getTriggersSummaryPaginate } from '../../../redux/thunks/triggerThunk';
import { Grid } from '@mui/material';
import TriggerEngagement from '../triggersSummary/triggerEngagement';
import TriggerTable from '../triggersSummary/table';
import DistrictBreakdown from './districtBreakdown';

const triggersSummary = () => {
    const dispatch = useDispatch();
    const { startDateRange, endDateRange } = useSelector((state) => state.filter);
    const { company } = useSelector((state) => state.company);
    const { triggerSummary } = useSelector((state) => state.trigger);
    const { companyConfig } = useSelector(state => state.adminSettings);
    const { value } = companyConfig;
    const { selectedTriggers,currentPage } = triggerSummary;
    const isInitialRender = useRef(true);
    const showMapChart = [33].includes(company.id);
    const isConfigReady = companyConfig && Object.keys(companyConfig).length > 0;
    useEffect(() => {
        if (isInitialRender.current) {
            isInitialRender.current = false;
            return;
        }
    
        if (company.id || isConfigReady) {
            dispatch(
                getTriggers({
                    companyId: company.id,
                    startRange: startDateRange,
                    endRange: endDateRange,
                    //isUnified: value?.toLowerCase() === 'true' || false
                })
            );
        }
    }, [startDateRange, endDateRange, isConfigReady]);
    useEffect(() => {
        if(selectedTriggers.length){
            if (!company.id || !selectedTriggers.length) return;
            const finalData = selectedTriggers.map(item => item.toLowerCase());
            const uniqueNames = [...new Set(finalData)];
    
            if (uniqueNames.length === finalData.length) {
                dispatch(getTriggersSummaryPaginate({
                    companyId: company.id,
                    startRange: startDateRange,
                    endRange: endDateRange,
                    batchNo: currentPage,
                    batchSize: 25,
                    triggerNames: { 'triggers': uniqueNames },
                    type: 'table'
                }));
            }
        }
        
    }, [selectedTriggers, currentPage]);

    useEffect(() => {
        if(selectedTriggers.length){
            if (!company.id || !selectedTriggers.length) return;

            const finalData = selectedTriggers.map(item => item.toLowerCase());
            const uniqueNames = [...new Set(finalData)];
    
            if (uniqueNames.length === finalData.length) {
                dispatch(getTriggersSummaryGraphs({
                    companyId: company.id,
                    startRange: startDateRange,
                    endRange: endDateRange,
                    triggerNames: { 'triggers': uniqueNames }
                }));
            }
        }
    }, [company,selectedTriggers]);
    return(
        <>
            <FilterBar />
            <Grid container spacing={2}>
                {/* Trigger Engagement */}
                <Grid item xs={12}>
                    <TriggerEngagement />
                </Grid>
                {
                    showMapChart && (
                        <Grid item xs={12}>
                            <DistrictBreakdown />
                        </Grid>
                    )
                }
                <Grid item xs={12} sx={{ minWidth: 0 }}>
                    <TriggerTable />
                </Grid>
          
            </Grid>
        </>
    );
};
export default triggersSummary;
